import { z } from "zod";

export const TrackingPostBodySchema = z.object({
  userAgreementTracking: z.boolean(),
});

// Use z.infer to create a type that matches the Zod schema
export type TrackingPostBody = z.infer<typeof TrackingPostBodySchema>;
